import { render, staticRenderFns } from "./tea.vue?vue&type=template&id=6a80b2d0&scoped=true&"
import script from "./tea.vue?vue&type=script&lang=js&"
export * from "./tea.vue?vue&type=script&lang=js&"
import style0 from "./tea.vue?vue&type=style&index=0&id=6a80b2d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80b2d0",
  null
  
)

export default component.exports